export default {
  set: function(coursework_id, data) {
    return new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.user_states_path(),
      data: { user_state: { stateable_id: coursework_id, stateable_type: 'Coursework', data: JSON.stringify(data) }}
    });
  },
  get: function (coursework_id) {
    return new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.user_states_path({ stateable_id: coursework_id, stateable_type: 'Coursework' })
    });
  },
  stepCompleted: function (coursework_id, step) {
    let state = {progress: {}};
    state['progress'][step] = true;
    return this.set(coursework_id, state);
  },
  isStepCompleted: function (coursework_id, step) {
    let deferred = $.Deferred();
    this.get(coursework_id).done(function (data, status, xhr) {
      let userState = data['user_state']['meta_data'] || {};
      let progress = userState['progress'] || {};
      deferred.resolve(progress[step]);
    });
    return deferred;
  }
};
